import { statusOptions } from "../../../../../../DataGridTable/FieldTypes/StatusCell";
import { getFieldByKey } from "../../../../../../hooks/useTableColumnsConfig";

// Format notes array for export
export const formatNotes = (value) => {
  const parseNotes = (notes) => {
    try {
      return Array.isArray(notes) ? notes : JSON.parse(notes);
    } catch {
      return [];
    }
  };
  const notes = parseNotes(value);
  return notes
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    .map(
      (note) =>
        `${note.text} (${note.author} - ${new Date(note.createdAt).toLocaleDateString()})`
    )
    .join("; ");
};

// Format audience data (countries, languages, etc.) for export
export const formatAudienceData = (value) => {
  const parseData = (data) => {
    try {
      return Array.isArray(data) ? data : JSON.parse(data);
    } catch {
      return [];
    }
  };
  const data = parseData(value);
  return data
    .slice(0, 10)
    .map((item) => {
      const key =
        item.country || item.language || item.city || item.mention || "Unknown";
      return `${key}: ${Number(item.value || 0).toFixed(1)}%`;
    })
    .join("; ");
};

// Format date values for export
export const formatDate = (value) => {
  try {
    const date = new Date(value);
    if (!isNaN(date.getTime())) {
      return `${date.toLocaleDateString("en-US")} ${date.toLocaleTimeString(
        "en-US",
        {
          hour: "2-digit",
          minute: "2-digit",
        }
      )}`;
    }
  } catch (e) {
    console.log(e);
  }
  return value;
};

// Format percentage values (handle both decimal and percentage formats)
export const formatPercentage = (value) => {
  const percentageValue = value > 1 ? value : value * 100;
  return `${percentageValue.toFixed(2)}%`;
};

// Main cell value formatter - handles all data types for export
export const formatCellValueForExport = ({
  value,
  columnName,
}) => {
  const columnObject = getFieldByKey({ columnKey: columnName });

  if (value === null || value === undefined) return "";
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (columnName === "notes") return formatNotes(value);
  if (
    columnName.includes("audience_countries_full") ||
    columnName.includes("audience_languages_full") ||
    columnName.includes("audience_cities_full") ||
    columnName.includes("audience_interests_full")
  ) {
    return formatAudienceData(value);
  }
  if (columnName === "status") {
    const statusOption = statusOptions.find((option) => option.value === value);
    return statusOption ? statusOption.label : value;
  }
  if (Array.isArray(value)) return value.length > 0 ? JSON.stringify(value) : "";
  if (typeof value === "object") return JSON.stringify(value);
  if (columnObject?.type === "percent" && typeof value === "number") {
    return formatPercentage(value);
  }
  if (typeof value === "number") {
    return Number.isInteger(value) ? value : parseFloat(value.toFixed(2));
  }
  if (
    columnName.includes("created_at") ||
    columnName.includes("date") ||
    columnName.includes("timestamp")
  ) {
    return formatDate(value);
  }
  if (columnName === "bio" && typeof value === "string") {
    return value.length > 200 ? value.substring(0, 200) + "..." : value;
  }
  if (
    (columnName.includes("url") ||
      columnName.includes("link") ||
      columnName === "website") &&
    typeof value === "string"
  ) {
    return value.trim();
  }
  if (
    (columnName.startsWith("country_") || columnName.startsWith("language_")) &&
    typeof value === "number"
  ) {
    return `${value.toFixed(1)}%`;
  }

  const cleanString = (str) => {
    if (typeof str !== "string") return str;
    return str
      .replace(/[\r\n\t]/g, " ")
      .replace(/"/g, '""')
      .trim();
  };

  return cleanString(String(value));
};
